/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteCompanyContactInput = {|
  companyId?: ?string,
  contactType?: ?string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type DeleteCompanyContactMutationVariables = {|
  input: DeleteCompanyContactInput
|};
export type DeleteCompanyContactMutationResponse = {|
  +deleteCompanyContact: ?{|
    +deletedContactId: ?string
  |}
|};
export type DeleteCompanyContactMutation = {|
  variables: DeleteCompanyContactMutationVariables,
  response: DeleteCompanyContactMutationResponse,
|};
*/


/*
mutation DeleteCompanyContactMutation(
  $input: DeleteCompanyContactInput!
) {
  deleteCompanyContact(input: $input) {
    deletedContactId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteCompanyContactInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteCompanyContactPayload",
    "kind": "LinkedField",
    "name": "deleteCompanyContact",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedContactId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteCompanyContactMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteCompanyContactMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "DeleteCompanyContactMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteCompanyContactMutation(\n  $input: DeleteCompanyContactInput!\n) {\n  deleteCompanyContact(input: $input) {\n    deletedContactId\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3a131c5ca3f753d60376bca9ffc0096c';

module.exports = node;
